import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-388fbc43"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "menus"
};
import { RouterLink } from "vue-router";
export default /*#__PURE__*/_defineComponent({
  __name: 'menu',
  setup(__props) {
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_unref(RouterLink), {
        to: "/recharge"
      }, {
        default: _withCtx(() => [_createTextVNode("充值金额")]),
        _: 1
      }), _createVNode(_unref(RouterLink), {
        to: "/refund"
      }, {
        default: _withCtx(() => [_createTextVNode("申请退款")]),
        _: 1
      }), _createVNode(_unref(RouterLink), {
        to: "/song"
      }, {
        default: _withCtx(() => [_createTextVNode("歌曲列表")]),
        _: 1
      }), _createVNode(_unref(RouterLink), {
        to: "/secure"
      }, {
        default: _withCtx(() => [_createTextVNode("密码安全")]),
        _: 1
      })]);
    };
  }
});